export default __webpack_public_path__ + "static/media/product_NPC_PC_En.7c5c7bea.webp";